<template>
	<div>
		<!-- <TilteParallax image="https://cdn.hipwallpaper.com/i/7/54/QSWLXT.png"> -->
		<TilteParallax
			image="https://apps.pinturasacuario.mx/assets/store/images/customer/search.jpg"
		>
			<div class="d-flex">
				<h1 class="display-1 font-weight-thin">
					Orden de compra:
				</h1>
				<div
					:class="[
						'd-flex align-center',
						$vuetify.breakpoint.smAndDown ? 'ml-0' : 'ml-2',
					]"
				>
					<h1 class="display-1 font-weight-thin">
						{{ $route.params.id }}
					</h1>

					<template v-if="salesOrder">
						<v-chip
							color="orange white--text"
							v-if="salesOrder.status"
							class="ml-2"
						>
							{{ salesOrder.status.name }}
						</v-chip>
					</template>
				</div>
			</div>

			<template v-slot:menu>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							fab
							v-on="on"
							elevation="5"
							v-bind="attrs"
							color="default"
						>
							<v-icon>
								mdi-dots-vertical
							</v-icon>
						</v-btn>
					</template>
					<v-list>
						<template v-if="salesOrder">
							<v-list-item @click="edit()">
								<v-list-item-title>
									Editar
								</v-list-item-title>
							</v-list-item>

							<template
								v-if="
									ui.type == 'edit' &&
										salesOrder.status_id == 1
								"
							>
								<v-list-item @click="cancel()">
									<v-list-item-title>
										Cancelar edición
									</v-list-item-title>
								</v-list-item>

								<v-list-item @click="salesorderImport()">
									<v-list-item-title>
										Importar desde CSV
									</v-list-item-title>
								</v-list-item>
							</template>
						</template>
					</v-list>
				</v-menu>
			</template>
		</TilteParallax>

		<v-container fluid class="pt-0">
			<v-row justify="center">
				<v-col cols="12" md="10">
					<v-card
						outlined
						:class="[
							'pt-0',
							$vuetify.breakpoint.smAndDown ? 'pa-0' : 'pa-4',
						]"
						:loading="ui.geting || ui.sending"
						:disabled="ui.geting || ui.sending"
					>
						<v-card-text
							:class="[{ 'pa-1': $vuetify.breakpoint.smAndDown }]"
						>
							<v-container fluid>
								<CreateUpdate
									v-if="salesOrder"
									:type="ui.type"
									:salesorder="salesOrder"
									@get="get()"
									@cancel="cancel()"
									@updated="updated()"
									@created="$router.go(-1)"
								>
								</CreateUpdate>
							</v-container>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import { v } from "@/main";
import axios from "axios";
import { EventBus } from "@/main";
import CreateUpdate from "@/components/SalesOrder/CreateUpdate";
import TilteParallax from "@/components/TilteParallax";

export default {
	name: "Create",

	components: { TilteParallax, CreateUpdate },

	data() {
		return {
			salesOrder: null,

			ui: {
				type: "show",
				geting: false,
				sending: false,
			},
		};
	},

	created() {
		this.get();

		EventBus.$on("SalesOrderSending", (val) => {
			this.ui.sending = val;
		});
	},

	methods: {
		async get() {
			try {
				this.ui.geting = true;
				let resp = await axios.get(
					`${process.env.VUE_APP_API_SERVER}/auth/customer/purchaceorder/${this.$route.params.id}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.state.acount.token}`,
						},
					}
				);

				this.salesOrder = {
					...resp.data.data,
					articles: resp.data.data.articles_with.map((article) => {
						return {
							...article,
							...{
								...article.pivot,
							},
							id: article.id,
						};
					}),
				};
			} catch (error) {
				try {
					switch (error.resp.status) {
						case 401:
							this.$store.dispatch("setTokenRefreshDialog", true);
							break;
						default:
							EventBus.$emit("Error", {
								error: error,
								errorsShow: true,
							});
							break;
					}
				} catch (e) {
					EventBus.$emit("Error", { error: error, errorsShow: true });
				}
			} finally {
				this.ui.geting = false;
			}
		},

		edit() {
			if (this.salesOrder.status_id != 1) {
				return EventBus.$emit("MessageGeneral", {
					title: "¡Atención!",
					subtitle: "No se puede completar esta acción.",
					message: `La orden de compra ya fue recibida por el área de ventas y no se puede modificar. Si necesita realizar alguna modificación, comuníquese con su agente de ventas.`,
				});
			}

			this.ui.type = "edit";
		},

		async cancel() {
			if (
				confirm(`¿Quiere cancelar la edición de esta orden de compra?`)
			) {
				await this.get();

				this.ui.type = "show";

				EventBus.$emit("Snackbar", {
					text: "Actualización cancelada.",
					type: "secondary",
				});
			}
		},

		async updated() {
			localStorage.removeItem("salesorder");

			this.ui.type = "show";

			await this.get();
		},

		salesorderImport() {
			EventBus.$emit("SalesorderImport");
		},
	},

	computed: {},
};
</script>

<style lang="css" scoped></style>
